import { useContext } from "react";
import { UserAuthContext } from "@/components/auth/UserAuthProvider.tsx";

export function useUserAuth() {
  const context = useContext(UserAuthContext);

  if (!context) {
    throw new Error("useUserAuth must be used within a UserAuthProvider");
  }

  return context;
}
